(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["berrypuff-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bp-welcome')) {
    customElements.define('bp-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.key = 'bp_welcome10_v1';
        this.dialog = this.querySelector('[data-welcome-dialog]');
        this.badge = this.querySelector('[data-welcome-open]');
        this.entry = this.querySelector('[data-welcome-entry]');
        this.success = this.querySelector('[data-welcome-success]');
        this.form = this.querySelector('form');
        this.isEditor = this.dataset.designMode === 'true';
        this.done = this.read('localStorage', this.key) === 'subscribed' || this.dataset.subscribed === 'true';
        this.dismissed = this.read('localStorage', this.key) === 'dismissed';
        this.returnFocus = null;
        this.started = Date.now();
        const attempt = Number(this.read('sessionStorage', this.key + '_pending'));
        const ownAttempt = (attempt > 0 && Date.now() - attempt >= 0 && Date.now() - attempt < 30 * 60 * 1000) || this.entry.dataset.context === 'bp-welcome10' || window.location.hash === '#' + this.form.id;
        const returned = this.read('sessionStorage', this.key + '_return');
        const previousPath = this.read('sessionStorage', this.key + '_origin');
        if ((ownAttempt || returned) && previousPath?.startsWith('/') && !previousPath.startsWith('//')) this.returnPath = previousPath;
        this.badge.addEventListener('click', () => this.open());
        this.querySelector('[data-welcome-close]').addEventListener('click', () => this.dismiss());
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.dismiss(); });
        this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dismiss(); } });
        this.form.addEventListener('submit', () => {
          if (!this.form.checkValidity()) return;
          this.write('sessionStorage', this.key + '_pending', String(Date.now()));
          this.write('sessionStorage', this.key + '_scroll', String(window.scrollY));
          this.write('sessionStorage', this.key + '_origin', window.location.pathname + window.location.search);
        });
        this.querySelector('[data-welcome-continue]').href = this.discountUrl();
        if (this.entry.dataset.posted === 'true' && ownAttempt && !this.isEditor) {
          this.done = true;
          this.write('localStorage', this.key, 'subscribed');
          this.write('sessionStorage', this.key + '_pending', '');
          this.showSuccess();
          if (this.write('sessionStorage', this.key + '_return', String(Date.now()))) {
            window.location.replace(this.discountUrl());
            return;
          }
          fetch(this.discountUrl(), { credentials: 'same-origin' }).catch(() => {});
        } else if (returned && Date.now() - Number(returned) < 5 * 60 * 1000) {
          this.done = true;
          this.write('sessionStorage', this.key + '_return', '');
          this.showSuccess();
          this.restoreScroll();
          this.write('sessionStorage', this.key + '_origin', '');
        } else if (this.entry.dataset.errors === 'true' && ownAttempt) {
          this.write('sessionStorage', this.key + '_pending', '');
          this.forceOpen = true;
        }
        this.tick = () => {
          if (document.visibilityState !== 'visible') return;
          if (this.done && !this.forceOpen && !this.dialog.open) { this.badge.hidden = true; return; }
          const blocked = this.blocked();
          this.badge.hidden = this.done || !this.dismissed || this.dialog.open || blocked;
          if (blocked && this.dialog.open) { this.dialog.close(); this.forceOpen = true; }
          if (blocked || document.visibilityState !== 'visible') return;
          if (this.forceOpen) { this.forceOpen = false; this.open(); }
          if (!this.done && !this.dismissed && !this.isEditor && Date.now() - this.started >= Number(this.dataset.delay) * 1000) this.open();
        };
        this.timer = window.setInterval(this.tick, 800);
        this.tick();
        this.editorSelect = (event) => { if (this.isEditor && event.target.contains(this)) this.open(); };
        document.addEventListener('shopify:section:select', this.editorSelect);
      }
      disconnectedCallback() { window.clearInterval(this.timer); document.removeEventListener('shopify:section:select', this.editorSelect); }
      read(storage, key) { try { return window[storage].getItem(key); } catch (_) { return null; } }
      write(storage, key, value) { try { if (value) window[storage].setItem(key, value); else window[storage].removeItem(key); return true; } catch (_) { return false; } }
      discountUrl() {
        const current = new URL(this.returnPath || window.location.href, window.location.origin);
        current.searchParams.delete('customer_posted');
        current.searchParams.delete('form_type');
        current.searchParams.delete('contact_posted');
        const redirect = current.pathname + current.search;
        const root = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '') + '/';
        return root + 'discount/' + encodeURIComponent(this.dataset.code) + '?redirect=' + encodeURIComponent(redirect);
      }
      blocked() {
        const visible = (element) => {
          if (!element || this.contains(element) || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
          const style = getComputedStyle(element);
          const box = element.getBoundingClientRect();
          return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < window.innerHeight;
        };
        return Array.from(document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs__dialog,dialog[open],[role="dialog"][aria-modal="true"],.drawer--is-open,.modal--is-active')).some(visible);
      }
      open() {
        if (this.dialog.open || this.blocked()) return;
        this.returnFocus = document.activeElement;
        this.badge.hidden = true;
        this.dismissed = true;
        if (!this.done && !this.isEditor) this.write('localStorage', this.key, 'dismissed');
        this.dialog.showModal();
        this.querySelector('[data-welcome-close]').focus({ preventScroll: true });
      }
      dismiss() {
        this.dialog.close();
        this.dismissed = true;
        if (!this.done && !this.isEditor) this.write('localStorage', this.key, 'dismissed');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.tick?.();
      }
      showSuccess() { this.entry.hidden = true; this.success.hidden = false; this.forceOpen = true; this.badge.hidden = true; }
      restoreScroll() {
        const y = Number(this.read('sessionStorage', this.key + '_scroll'));
        this.write('sessionStorage', this.key + '_scroll', '');
        if (y > 0) requestAnimationFrame(() => window.scrollTo({ top: y, behavior: 'instant' }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp-rivestimenti-richiesta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bp-atelier')) {
    class BerryPuffAtelier extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-atelier-open]');
        if (!this.dialog || !this.opener || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.opener.setAttribute('aria-haspopup', 'dialog');
        this.opener.addEventListener('click', (event) => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.openCatalog();
        }, options);
        this.querySelector('[data-atelier-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.restorePage(), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dialog.close();
        }, options);
      }

      openCatalog() {
        if (this.dialog.open) return;
        this.returnFocus = document.activeElement;
        this.scrollX = window.scrollX;
        this.scrollY = window.scrollY;
        this.savedStyle = new Map();
        const body = document.body;
        ['position', 'top', 'left', 'width', 'overflow', 'padding-right'].forEach((property) => {
          this.savedStyle.set(property, [body.style.getPropertyValue(property), body.style.getPropertyPriority(property)]);
        });
        const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        const padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        this.dialog.showModal();
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `-${this.scrollY}px`);
        body.style.setProperty('left', `-${this.scrollX}px`);
        body.style.setProperty('width', '100%');
        body.style.setProperty('overflow', 'hidden');
        if (scrollbar) body.style.setProperty('padding-right', `${padding + scrollbar}px`);
        const pages = this.querySelector('.bp-atelier__pages');
        const pageTemplate = this.querySelector('[data-atelier-pages]');
        if (pages && pageTemplate) {
          pages.append(pageTemplate.content.cloneNode(true));
          pageTemplate.remove();
        }
        const pdf = this.querySelector('[data-atelier-pdf]');
        if (pdf && !pdf.hasAttribute('src')) pdf.src = pdf.dataset.atelierPdf;
        this.querySelector('[data-atelier-close]').focus({ preventScroll: true });
      }

      restorePage() {
        if (!this.savedStyle) return;
        this.savedStyle.forEach(([value, priority], property) => {
          if (value) document.body.style.setProperty(property, value, priority);
          else document.body.style.removeProperty(property);
        });
        this.savedStyle = null;
        window.scrollTo({ left: this.scrollX, top: this.scrollY, behavior: 'instant' });
        if (this.returnFocus && this.returnFocus.isConnected) this.returnFocus.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.restorePage();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    }
    customElements.define('bp-atelier', BerryPuffAtelier);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
